import { useApiHubPlan } from '~/portal/hooks/useApiHubPlan'
import { ApiHubGates } from '~/shared/types/portal'

export const useEntitlements = (): ApiHubGates => {
  const apiHubPlan = useApiHubPlan()

  return apiHubPlan.platformManaged && apiHubPlan.gates ? apiHubPlan.gates : {
    sbFooterRemoved: true,
    subdomainEditingEnabled: !apiHubPlan.trial,
    customDomainEnabled: true,
    consumerSideOnline: true,
    requestAccessEnabled: true,
    attachmentManagerEnabled: true,
    ckEditorEnabled: true,
    privateAndHiddenProductsEnabled: true,
    collaborationEnabled: true,
    personalizationEnabled: true,
  }
}